<template>
  <div class="home" :class="{ 'is-en': isEn }">
    <site-header />
    <section class="banner">
      <div class="banner-bg" :style="{ backgroundImage: 'url(' + fileUrl('index/banner_1.jpg') + ')' }"></div>
      <div class="banner-stage">
        <div class="banner-card"></div>
        <div class="en">TRANSPORTATION</div>
        <div class="name-blue">{{ copy.home.nameBlue }}</div>
        <div class="name-dark">{{ copy.home.nameDark }}</div>
        <div class="slogan">{{ copy.home.slogan }}</div>
      </div>
    </section>

    <section class="transport">
      <div class="transport-head">
        <span class="name">{{ copy.home.transportName }}</span>
        <span class="name-blue">{{ copy.home.transportNameBlue }}</span>
        <div class="en-title">TRANSPORT LINE</div>
        <div class="transport-copy">
          <p>{{ copy.home.transportCopy1 }}</p>
          <p v-if="copy.home.transportCopy2">{{ copy.home.transportCopy2 }}</p>
        </div>
      </div>
      <div class="mode-stage">
        <div v-for="(item, index) in modeList" :key="item.key" class="mode wow-fade" :style="delayStyle(index)">
          <img :src="fileUrl(item.image)" :alt="item.name">
          <span>{{ item.name }}</span>
        </div>
      </div>
    </section>

    <section class="about">
      <div class="about-blue"></div>
      <img class="about-photo" :src="fileUrl('index/关于我们图标.png')" :alt="copy.home.aboutTitle">
      <div class="about-stage">
        <h2>{{ copy.home.aboutTitle }}</h2>
        <div class="about-en">{{ copy.home.aboutEn }}</div>
        <div class="about-copy">
          <p v-for="(text, index) in copy.home.aboutParagraphs" :key="index">{{ text }}</p>
        </div>
      </div>
    </section>

    <section class="features">
      <div class="feature-list">
        <article v-for="(item, index) in featureList" :key="item.no" class="feature wow-down" :style="delayStyle(index)">
          <div class="no">{{ item.no }}</div>
          <h3>{{ item.title }}</h3>
          <p>{{ item.desc }}</p>
          <img :src="fileUrl(item.image)" :alt="item.title">
        </article>
      </div>
    </section>

    <section class="partners" :style="partnerStyle">
      <div class="partners-head">
        <div class="cn">{{ copy.home.partnersCn }}</div>
        <div class="cn-em">{{ copy.home.partnersEm }}</div>
        <div class="partners-en">Partners - Shipping Company</div>
      </div>
      <div class="logo-wrap">
        <div class="logo-grid wow-left" style="animation-delay: 0.25s">
          <div v-for="logo in logos" :key="logo" class="logo-item">
            <img :src="fileUrl(logo)" alt="合作伙伴">
          </div>
        </div>
      </div>
    </section>

    <site-footer />
  </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader.vue'
import SiteFooter from '@/components/SiteFooter.vue'
import { fileUrl } from '@/utils/fileUrl'
import { getCopy } from '@/locale'

export default {
  name: 'HomePage',
  components: {
    SiteHeader,
    SiteFooter
  },
  data() {
    return {
      observer: null,
      logos: [
        'index/背景/01.jpg',
        'index/背景/02.jpg',
        'index/背景/03.png',
        'index/背景/04.png',
        'index/背景/05.png',
        'index/背景/06.jpg',
        'index/背景/07.jpg',
        'index/背景/08.jpg',
        'index/背景/09.png',
        'index/背景/10.jpg',
        'index/背景/11.png',
        'index/背景/12.png',
        'index/背景/13.png',
        'index/背景/14.png',
        'index/背景/15.jpg',
        'index/背景/16.png',
        'index/背景/17.png',
        'index/背景/18.png'
      ]
    }
  },
  computed: {
    /** 是否英文站 */
    isEn() {
      return this.$route.meta && this.$route.meta.lang === 'en'
    },
    /** 当前页语言文案 */
    copy() {
      return getCopy(this.isEn ? 'en' : 'zh')
    },
    modeList() {
      const n = this.copy.nav
      return [
        { key: 'water', name: n.water, image: 'index/modeOfTransport_1.jpg' },
        { key: 'road', name: n.road, image: 'index/modeOfTransport_4.jpg' },
        { key: 'rail', name: n.rail, image: 'index/modeOfTransport_2.jpg' },
        { key: 'air', name: n.air, image: 'index/modeOfTransport_3.jpg' }
      ]
    },
    featureList() {
      const h = this.copy.home
      return [
        { no: '01', title: h.feature1Title, desc: h.feature1Desc, image: 'index/展示-02.jpg' },
        { no: '02', title: h.feature2Title, desc: h.feature2Desc, image: 'index/展示-03.jpg' },
        { no: '03', title: h.feature3Title, desc: h.feature3Desc, image: 'index/合作伙伴.jpg' }
      ]
    },
    partnerStyle() {
      return {
        backgroundImage: 'url(' + fileUrl('index/背景/news_bg.jpg') + ')'
      }
    }
  },
  mounted() {
    this.bindScrollAnim()
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect()
    }
  },
  methods: {
    /** 拼接文件服务器上的图片地址 */
    fileUrl(path) {
      return fileUrl(path)
    },
    /** 依次延迟，对应官网 wow 的 data-wow-delay */
    delayStyle(index) {
      return { animationDelay: (index * 0.12) + 's' }
    },
    /** 滚动进入视口后播放 fadeIn / slideInLeft */
    bindScrollAnim() {
      const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in')
          }
        })
      }, { threshold: 0.15 })
      this.observer = observer
      const nodes = this.$el.querySelectorAll('.wow-fade, .wow-left, .wow-down')
      nodes.forEach(function (node) {
        observer.observe(node)
      })
    }
  }
}
</script>

<style scoped>
.home {
  background: #fff;
  color: #333;
  font-family: "Microsoft YaHei", Arial, sans-serif;
}
.banner {
  position: relative;
  height: 613px;
  overflow: hidden;
  background: #fff;
}
.banner-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: 100% auto;
  background-attachment: fixed;
}
.banner-stage {
  position: absolute;
  width: 1200px;
  height: 317px;
  top: 129.5px;
  left: 18.503937%;
}
.banner-card {
  position: absolute;
  width: 790px;
  height: 240px;
  top: 41px;
  left: 17.083333%;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.7);
}
.banner-stage .en,
.banner-stage .name-blue,
.banner-stage .name-dark,
.banner-stage .slogan {
  position: absolute;
  margin: 0;
  font-family: "Microsoft YaHei", sans-serif;
  white-space: nowrap;
}
.banner-stage .en {
  width: 46.083333%;
  top: 81px;
  left: 26.958333%;
  height: 50px;
  line-height: 50px;
  font-size: 30px;
  color: #333;
  text-align: center;
}
.banner-stage .name-blue {
  width: 23.666667%;
  top: 149px;
  left: 28%;
  height: 50px;
  line-height: 50px;
  font-size: 46px;
  font-weight: bold;
  color: #3db7ef;
  text-align: right;
}
.banner-stage .name-dark {
  width: 23.083333%;
  top: 149px;
  left: 51.75%;
  height: 50px;
  line-height: 50px;
  font-size: 46px;
  font-weight: bold;
  color: #333;
  text-align: left;
}
.banner-stage .slogan {
  width: 63.583333%;
  top: 222px;
  left: 18.208333%;
  height: 50px;
  line-height: 50px;
  font-size: 16px;
  color: #2c4058;
  text-align: center;
}
.transport {
  background: #fff;
}
.transport-head {
  position: relative;
  max-width: 1200px;
  height: 263px;
  margin: 0 auto;
}
.transport-head .name,
.transport-head .name-blue {
  position: absolute;
  top: 55px;
  z-index: 2;
  margin: 0;
  font-size: 30px;
  line-height: 50px;
  letter-spacing: 2px;
  background: #fff;
}
.transport-head .name {
  left: 43.166667%;
  width: 6.666667%;
  color: #333;
  text-align: right;
}
.transport-head .name-blue {
  left: 49.916667%;
  width: 7.25%;
  color: #3db7ef;
  font-weight: bold;
  text-align: left;
}
.en-title {
  position: absolute;
  top: 83px;
  left: 35.708333%;
  width: 28.583333%;
  margin: 0;
  border-top: 1px dashed #3db7ef;
  line-height: 90px;
  font-family: Tahoma, sans-serif;
  font-size: 22px;
  font-weight: bold;
  color: #e5e5e5;
  text-align: center;
}
.transport-copy {
  position: absolute;
  top: 166px;
  left: 0;
  width: 100%;
  color: #a2a2a2;
  font-size: 16px;
  line-height: 35px;
  text-align: center;
}
.transport-copy p { margin: 0; }
.mode-stage {
  position: relative;
  max-width: 1200px;
  height: 342px;
  margin: 0 auto;
}
.mode { position: absolute; top: 0; }
.mode:nth-child(1) { left: 0; width: 280px; }
.mode:nth-child(2) { left: 307px; width: 23.333333%; }
.mode:nth-child(3) { left: 614px; width: 23.333333%; }
.mode:nth-child(4) { left: 76.5%; width: 23.416667%; }
.mode img {
  width: 100%;
  height: 221px;
  object-fit: cover;
  display: block;
}
.mode span {
  position: absolute;
  top: 234px;
  left: 50%;
  width: 192px;
  transform: translateX(-50%);
  color: #333;
  font-size: 18px;
  line-height: 20px;
  text-align: center;
}
.about {
  position: relative;
  height: 597px;
  background: #fff;
}
.about-blue {
  position: absolute;
  top: 0;
  left: 0;
  width: 50%;
  height: 546px;
  background: #3db7ef;
}
.about-photo {
  position: absolute;
  top: 0;
  left: 49.964863%;
  width: 50%;
  height: 546px;
  object-fit: cover;
}
.about-stage {
  position: absolute;
  top: 77px;
  left: calc(50% - 600px);
  width: 1200px;
  height: 419px;
  z-index: 2;
}
.about-stage h2 {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 3;
  width: 54.875%;
  margin: 0;
  color: #fff;
  font-size: 30px;
  font-weight: bold;
  line-height: 50px;
}
.about-en {
  position: absolute;
  top: 62px;
  left: 0;
  z-index: 2;
  width: 49.5%;
  margin: 0;
  font-family: Verdana, sans-serif;
  font-size: 22px;
  font-weight: bold;
  line-height: 30px;
  color: #e5e5e5;
}
.about-copy {
  position: absolute;
  top: 119px;
  left: 0;
  z-index: 4;
  width: 46.5%;
  color: #fff;
  font-size: 16px;
  line-height: 25px;
  text-align: justify;
  letter-spacing: 2px;
}
.about-copy p {
  margin: 0;
  text-indent: 2em;
}
.features {
  height: 517px;
  background: #fff;
}
.feature-list {
  position: relative;
  max-width: 1200px;
  height: 100%;
  margin: 0 auto;
}
.feature {
  position: absolute;
  top: 4px;
  width: 28%;
  height: 495px;
  background: #fff;
  color: #333;
  box-shadow: 5px 5px 9px #999;
  text-align: left;
}
.feature:nth-child(1) { left: 4%; }
.feature:nth-child(2) { left: 36%; }
.feature:nth-child(3) { left: 68%; }
.feature .no,
.feature h3,
.feature p,
.feature img {
  position: absolute;
  margin: 0;
}
.feature .no {
  top: 50px;
  left: 10%;
  width: 85%;
  font-size: 68px;
  line-height: 75px;
  font-weight: normal;
  color: #333;
}
.feature h3 {
  top: 150px;
  left: 10%;
  width: 80%;
  font-size: 18px;
  line-height: 25px;
  font-weight: normal;
  color: #333;
}
.feature p {
  top: 200px;
  left: 10%;
  width: 80%;
  font-size: 16px;
  line-height: 1.8;
  color: #333;
}
.feature img {
  top: 275px;
  left: 10%;
  width: 80%;
  height: 170px;
  object-fit: fill;
}
.partners {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 0;
  background-attachment: fixed;
}
.partners-head {
  position: relative;
  height: 193px;
  max-width: 1200px;
  margin: 0 auto;
}
.partners-head .cn,
.partners-head .cn-em {
  position: absolute;
  top: 55px;
  height: 50px;
  margin: 0;
  font-size: 30px;
  line-height: 50px;
  letter-spacing: 2px;
  font-family: "Microsoft YaHei", sans-serif;
  white-space: nowrap;
}
.partners-head .cn {
  left: 36.166667%;
  width: 15.083333%;
  color: #fff;
  text-align: right;
}
.partners-head .cn-em {
  left: 52.083333%;
  width: 9.25%;
  color: #3db7ef;
  font-weight: bold;
  text-align: left;
}
.partners-en {
  position: absolute;
  top: 83px;
  left: 34.458333%;
  width: 28.583333%;
  margin: 0;
  font-family: Tahoma, Arial, sans-serif;
  font-size: 22px;
  font-weight: bold;
  line-height: 90px;
  color: #e5e5e5;
  text-align: center;
}
.logo-wrap {
  position: relative;
  height: 696px;
  max-width: 1200px;
  margin: 0 auto;
}
.logo-grid {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.logo-item {
  position: relative;
  width: 15%;
  margin-bottom: 2%;
  background: #fff;
  overflow: hidden;
}
.logo-item::before {
  content: "";
  display: block;
  padding-top: 84.210526%;
}
.logo-item img {
  position: absolute;
  top: 50%;
  left: 50%;
  height: 100%;
  width: auto;
  max-width: none;
  transform: translate(-50%, -50%);
  transition: transform 0.3s ease;
}
.logo-item:hover img {
  transform: translate(-50%, -50%) scale(1.1);
}
.wow-fade,
.wow-left,
.wow-down {
  opacity: 0;
}
.wow-fade.is-in {
  animation: fadeIn 1s both;
}
.wow-left.is-in {
  animation: slideInLeft 1s both;
}
.wow-down.is-in {
  animation: slideInDown 1s both;
}
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translate3d(-80px, 0, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
@keyframes slideInDown {
  from {
    opacity: 0;
    transform: translate3d(0, -80px, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
/* 英文站 banner 对齐官网 index_EN.html：加宽白底卡 + 缩小标题字号 */
.home.is-en .banner-card {
  width: 993px;
  height: 255px;
  top: 34px;
  left: 9.166667%;
}
.home.is-en .banner-stage .en {
  top: 74px;
  font-size: 30px;
}
.home.is-en .banner-stage .name-blue {
  top: 142px;
  left: 12%;
  width: 36.25%;
  font-size: 26px;
  line-height: 58px;
  text-align: right;
}
.home.is-en .banner-stage .name-dark {
  top: 142px;
  left: 48.166667%;
  width: 39.666667%;
  font-size: 26px;
  line-height: 58px;
  text-align: left;
}
.home.is-en .banner-stage .slogan {
  top: 215px;
  font-size: 16px;
}
.home.is-en .transport-head .name {
  left: 36.583333%;
  width: 15.083333%;
}
.home.is-en .transport-head .name-blue {
  left: 51.666667%;
  width: 15.916667%;
}
.home.is-en .en-title {
  left: 27.041667%;
  width: 48.916667%;
}
/* 英文站关于我们：高度/双标题层/正文字距对齐官网，文案仍用本地英文 */
.home.is-en .about { height: 890px; }
.home.is-en .about-blue,
.home.is-en .about-photo { height: 812px; }
.home.is-en .about-stage { height: 733px; }
.home.is-en .about-stage h2 {
  width: 47.333333%;
  font-size: 30px;
}
.home.is-en .about-en {
  top: 62px;
  width: 49.5%;
  color: #e5e5e5;
  font-size: 22px;
}
.home.is-en .about-copy {
  top: 119px;
  left: 0;
  width: 46.5%;
  font-size: 16px;
  line-height: 25px;
  letter-spacing: 0;
  text-align: justify;
}
.home.is-en .about-copy p {
  text-indent: 2em;
  margin: 0;
}
.home.is-en .about-copy p + p {
  margin-top: 0;
}
.home.is-en .features { height: 696px; }
.home.is-en .feature { height: 570px; }
.home.is-en .feature img { top: 340px; }
.home.is-en .partners-head .cn {
  left: 30.25%;
  width: 15.083333%;
}
.home.is-en .partners-head .cn-em {
  left: 46.166667%;
  width: 28%;
}
@media (min-width: 641px) and (max-width: 1200px) {
  .banner { height: 330px; }
  .banner-bg { height: 330px; }
  .banner-stage {
    width: 85.04772%;
    left: 7.47614%;
    top: 39px;
    height: 214px;
  }
  .banner-card {
    left: 5.236908%;
    width: 89.526185%;
    top: 9px;
    height: 196px;
  }
  .banner-stage .name-blue { left: 37.864529%; top: 91px; font-size: 26px; }
  .banner-stage .name-dark { left: 47.196448%; top: 91px; font-size: 26px; }
  .banner-stage .en {
    left: 18.716861%;
    width: 62.566278%;
    top: 39px;
    font-size: 26px;
  }
  .banner-stage .slogan {
    left: 6.670823%;
    width: 86.658354%;
    top: 165px;
    height: 20px;
    line-height: 20px;
    font-size: 14px;
  }
}
@media (min-width: 641px) and (max-width: 1200px) {
  .about { height: 352px; }
  .about-blue { height: 352px; }
  .about-photo { height: 351px; }
  .about-stage { width: 96%; left: 2%; top: 23px; height: 306px; }
  .about-stage h2 { width: 100%; }
  .about-en { top: 55px; }
  .about-copy { top: 106px; font-size: 14px; }
  .feature .no,
  .feature h3,
  .feature p { left: 25%; width: 50%; }
  .feature img { left: 0; width: 100%; }
  .transport-head { height: 223px; }
  .transport-head .name,
  .transport-head .name-blue { top: 31px; font-size: 28px; }
  .transport-head .name { left: 43.123674%; width: 67px; }
  .transport-head .name-blue { left: 50.102731%; width: 7.604167%; }
  .en-title { top: 55px; left: 35.708008%; }
  .transport-copy { top: 123px; left: 24.166556%; width: 496px; font-size: 14px; }
  .mode-stage { height: 339px; }
  .mode img { height: 184px; }
  .mode span { top: 200px; font-size: 16px; }
  .mode:nth-child(1) { left: 0.71083%; width: 24%; }
  .mode:nth-child(2) { left: 25.604785%; width: 24%; }
  .mode:nth-child(3) { left: 50.392696%; width: 24%; }
  .mode:nth-child(4) { left: 75.286652%; width: 24%; }
}
@media (max-width: 640px) {
  .about { height: 665px; }
  .about-blue { width: 100%; height: 395px; }
  .about-photo { width: 100%; height: 270px; top: 395px; left: 0; }
  .about-stage { width: 96%; height: 367px; top: 26px; left: 1.973684%; }
  .about-stage h2 { width: 100%; font-size: 26px; text-align: center; }
  .about-en { width: 100%; top: 50px; font-size: 20px; text-align: center; }
  .about-copy { width: 100%; top: 92px; font-size: 14px; }
  .features { height: auto; padding-bottom: 16px; }
  .feature-list { height: auto; }
  .feature {
    position: relative;
    left: auto;
    width: 92%;
    height: 300px;
    margin: 0 auto 16px;
  }
  .feature .no { top: 12px; left: 8%; width: 84%; font-size: 48px; line-height: 56px; }
  .feature h3 { top: 72px; left: 8%; width: 84%; }
  .feature p { top: 104px; left: 8%; width: 84%; font-size: 14px; line-height: 1.6; }
  .feature img { top: 166px; left: 8%; width: 84%; height: 120px; }
}
@media (max-width: 1024px) {
  .partners-head { height: 177px; }
  .partners-head .cn,
  .partners-head .cn-em { top: 31px; font-size: 28px; }
  .partners-head .cn { left: 43.123674%; width: 67px; }
  .partners-head .cn-em { left: 50.102731%; width: 7.604167%; }
  .partners-en { top: 55px; left: 35.708008%; }
  .logo-wrap { height: auto; }
  .logo-grid { position: relative; }
  .logo-item { width: 23.5%; }
}
@media (max-width: 640px) {
  .banner { height: 150px; }
  .banner-bg { height: 150px; background-attachment: scroll; }
  .banner-stage {
    width: 67.105263%;
    height: 96px;
    top: 14px;
    left: 16.447368%;
  }
  .banner-card {
    width: 246px;
    height: 68px;
    top: 9px;
    left: calc(50% - 123px);
    background: rgba(255, 255, 255, 0.6);
  }
  .banner-stage .name-dark {
    width: 34.509804%;
    top: 41px;
    left: 42.561275%;
    height: 30px;
    line-height: 30px;
    font-size: 18px;
  }
  .banner-stage .name-blue {
    width: 18.823529%;
    top: 42px;
    left: 23.859012%;
    height: 30px;
    line-height: 30px;
    font-size: 18px;
  }
  .banner-stage .en {
    width: 224px;
    top: 19px;
    left: 6.078431%;
    height: 20px;
    line-height: 20px;
    font-size: 16px;
  }
  .banner-stage .slogan { display: none; }
  .transport-head { height: 228px; }
  .transport-head .name,
  .transport-head .name-blue { top: 20px; font-size: 26px; }
  .transport-head .name { left: 31.015625%; width: 19.0625%; }
  .transport-head .name-blue { left: 50.263158%; width: 19.6875%; }
  .en-title { top: 48px; left: 18.947368%; width: 62.105263%; height: 70px; line-height: 80px; }
  .transport-copy { top: 120px; left: 1.315789%; width: 97.368421%; font-size: 12px; }
  .mode-stage { height: 485px; }
  .mode img { height: 146px; }
  .mode span { top: 156px; width: 120px; font-size: 16px; }
  .mode:nth-child(1) { left: 1.315789%; width: 47.3%; }
  .mode:nth-child(2) { left: 51.019737%; width: 47.368421%; }
  .mode:nth-child(3) { left: 1.315789%; top: 203px; width: 47.3%; }
  .mode:nth-child(4) { left: 51.019737%; top: 203px; width: 47.3%; }
  .partners-head { height: 138px; }
  .partners-head .cn,
  .partners-head .cn-em { top: 20px; font-size: 26px; }
  .partners-head .cn { left: 31.640625%; width: 18.4375%; }
  .partners-head .cn-em { left: 50.263158%; width: 19.375%; }
  .partners-en {
    top: 46px;
    left: 18.947368%;
    width: 62.105263%;
    height: 70px;
    line-height: 80px;
  }
  .logo-item { width: 49%; }
}
</style>
